/* eslint-disable react/require-default-props */
import React from 'react';
// @ts-ignore
import { FormattedHTMLMessage } from 'react-intl';
import {
    getFaqLink,
    getLocaleSafely,
    LinkExternal,
    VerificationService,
} from '@sheerid/jslib';

interface Props {
  verificationService: VerificationService;
  linkText?: string;
}

const FaqLinkComponent = ({ verificationService, linkText }: Props) => {
    const { segment } = verificationService.verificationResponse;
    const { programId, programTheme } = verificationService;

    if (segment) {
        const faqHref = getFaqLink(
            programTheme,
            segment,
            programId,
            getLocaleSafely(verificationService.viewModel),
        );

        return (
            <LinkExternal className="sid-faq sid-link" href={faqHref}>
                {linkText || <FormattedHTMLMessage id="step.docUpload.getHelpLink" defaultMessage="Get help" />}
            </LinkExternal>
        );
    }
    return null;
};

export { FaqLinkComponent };
